import { render, staticRenderFns } from "./PlanHeader.vue?vue&type=template&id=18f30436"
import script from "./PlanHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./PlanHeader.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports